import React from "react";
import { WordPressPost } from "./WordPressPost";
import { Link, useParams } from "react-router-dom";

function WordpressArchivedPost() {
  const { slug, id } = useParams<any>();
  return (
    <div>
      <p
        style={{
          textAlign: "center",
          fontSize: "24px",
          fontWeight: 700,
          border: "2px solid orange",
          backgroundColor: "#fef4e2",
          padding: "32px",
          borderRadius: "10px",
          maxWidth: 936,
          margin: "56px auto -24px",
        }}
      >
        This is an archived version of our {slug}. View the <Link to={`/${slug}`}>current version</Link> or{" "}
        <Link to={`/${slug}/archive`}>all past versions</Link>.
      </p>
      <WordPressPost postId={id} />
    </div>
  );
}

export default WordpressArchivedPost;
